import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {clearPhoneVerificationTimerLS} from "@pg-mono/user";

import {unstyledButton} from "@/styles/receipes/unstyled_button";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {maskPhoneNumber} from "../../utils/mask_phone_number";

const {SMS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    isSubmitting?: boolean;
    onChangeNumber: () => void;
    phone: string;
}

export const HomeMatchPreferencesWizardSmsDescription = (props: IProps) => {
    const {isSubmitting = false, onChangeNumber, phone} = props;
    const changeNumber = () => {
        if (isSubmitting) return;

        clearPhoneVerificationTimerLS();
        onChangeNumber();
    };

    return (
        <>
            {SMS.DESCRIPTION}{" "}
            <Text as="span" preserveFontSize strong variant="body_copy_2">
                {maskPhoneNumber(phone)}
            </Text>
            .{" "}
            <button className={changeNumberStyle} onClick={changeNumber} type="button">
                {SMS.CHANGE_NUMBER}
            </button>
        </>
    );
};

const changeNumberStyle = css(unstyledButton, {
    color: "inherit",
    textDecoration: "underline"
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {clearPhoneVerificationTimerLS} from "@pg-mono/user";

import {unstyledButton} from "@/styles/receipes/unstyled_button";

import {HOME_MATCH_PREFERENCES_WIZARD_CONTENT} from "../../constants/preferences/home_match_preferences_wizard_content";
import {maskPhoneNumber} from "../../utils/mask_phone_number";

const {SMS} = HOME_MATCH_PREFERENCES_WIZARD_CONTENT;

interface IProps {
    isSubmitting?: boolean;
    onChangeNumber: () => void;
    phone: string;
}

export const HomeMatchPreferencesWizardSmsDescription = (props: IProps) => {
    const {isSubmitting = false, onChangeNumber, phone} = props;
    const changeNumber = () => {
        if (isSubmitting) return;

        clearPhoneVerificationTimerLS();
        onChangeNumber();
    };

    return (
        <>
            {SMS.DESCRIPTION}{" "}
            <Text as="span" preserveFontSize strong variant="body_copy_2">
                {maskPhoneNumber(phone)}
            </Text>
            .{" "}
            <button className={changeNumberStyle} onClick={changeNumber} type="button">
                {SMS.CHANGE_NUMBER}
            </button>
        </>
    );
};

const changeNumberStyle = css(unstyledButton, {
    color: "inherit",
    textDecoration: "underline"
});
